import { Card, Grid, Stack } from "@mui/material";
import FormProvider from "../../../../../components/hook-form/form-provider";
import useUpdateDataUser from "./useUpdateData";
import { RHFAutocomplete, RHFTextField } from "../../../../../components/hook-form";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { IBranch } from "../../../../../types/branch";
import { LoadingButton } from "@mui/lab";
import { IDepartment } from "../../../../../types/department";

const UpdateDataUserView = () => {

    const { methods, onSubmit, departments, branches, selectedBranch, setSelectedBranch, selectedDepartment, setSelectedDepartment, setValue, isSubmitting } = useUpdateDataUser();

    return (
        <FormProvider methods={methods} onSubmit={onSubmit}>
            <Stack component={Card} spacing={3} sx={{ p: 3 }}>
                <Grid2 container spacing={3}>
                    <Grid2 xs={12}>
                        <RHFTextField
                            label="Nome Completo"
                            name="name"
                        />
                    </Grid2>
                    <Grid2 xs={6}>
                        <RHFTextField
                            label="Usuário"
                            name="username"
                        />
                    </Grid2>
                    <Grid2 xs={6}>
                        <RHFTextField
                            label="E-mail"
                            name="email"
                        />
                    </Grid2>
                    <Grid2 xs={6}>
                        <RHFAutocomplete
                            label="Filial"
                            name="branch"
                            options={branches}
                            placeholder="Selecione uma filial"
                            getOptionLabel={(branch: any) => `${branch.code} - ${branch.name}`}
                            renderOption={(props, branch) => (
                                <li {...props} key={branch.id}>
                                    {branch.code} - {branch.name}
                                </li>
                            )}
                            value={selectedBranch}
                            onChange={(event: any, newValue: any) => {
                                setSelectedBranch(newValue);
                                setValue("branch", newValue, { shouldValidate: true });
                                setSelectedDepartment(null);
                                setValue("department", null!, { shouldValidate: true });
                            }}
                            isOptionEqualToValue={(option: IBranch, value: IBranch) => option.id == value.id}
                        />
                    </Grid2>
                    <Grid2 xs={6}>
                        <RHFAutocomplete
                            label="Departamento"
                            name="department"
                            options={selectedBranch && departments?.filter(department => department.branch.id == selectedBranch?.id) || []}
                            placeholder="Selecione uma filial"
                            getOptionLabel={(department: any) => `${department.branch.code} - ${department.name}`}
                            renderOption={(props, department) => (
                                <li {...props} key={department.id}>
                                    {department.branch.code} - {department.name}
                                </li>
                            )}
                            value={selectedDepartment}
                            onChange={(event: any, newValue: any) => {
                                setSelectedDepartment(newValue);
                                setValue("department", newValue, { shouldValidate: true });
                            }}
                            isOptionEqualToValue={(option: IDepartment, value: IDepartment) => option.id == value.id}
                        />
                    </Grid2>
                    <Grid2 xs={12}>
                        <Stack justifyContent={'flex-end'}>
                            <LoadingButton type="submit" variant="contained" loading={isSubmitting} sx={{ ml: 'auto' }}>
                                Salvar
                            </LoadingButton>
                        </Stack>
                    </Grid2>
                </Grid2>
            </Stack>
        </FormProvider>
    );

}

export default UpdateDataUserView;